/**
 * typed-display.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import {
  Component,
  Input,
  OnInit
} from "@angular/core";
import { TypedDataHolder } from "./typed-data";

/**
 * {@link TypedDisplayComponent} is effectively a simplified version of the
 * {@link TypedControlComponent} that only displays the typed data, rather than
 * providing a means to interact with it.
 */
@Component({
  selector: "typed-display",
  template: `
    <span *ngIf="input?.type && input?.value !== null" [ngSwitch]="input.type">
      <!-- NOTE: Be careful with the switch cases: the structural *-syntax has
        been unrolled into templates to simplify the nesting of endless spans
        as well as make the string literal comparisons easier -->
      <template ngSwitchCase="date">
        <span *ngIf="!arraylike()">
          {{val() | utcDate}}
        </span>
        <span *ngIf="arraylike()">
          Non-singular dates not yet supported!
        </span>
      </template>
      <template ngSwitchCase="datetime">
        <span *ngIf="!arraylike()">
          {{val() | date:'medium'}}
        </span>
        <span *ngIf="arraylike()">
          Non-singular datetimes not yet supported!
        </span>
      </template>
      <template ngSwitchCase="boolean">
        <span *ngIf="!arraylike()">
         {{val() ? 'yes' : 'no'}}
        </span>
        <span *ngIf="arraylike()">
          Non-singular booleans not yet supported!
        </span>
      </template>
      <template ngSwitchDefault>
        <span *ngIf="!arraylike()">
          {{val()}}
        </span>
        <span *ngIf="arraylike()">
          <!-- NOTE: the parens before and after are HTML string (literals) -->
          ({{(val() | join) || " "}})
        </span>
      </template>
    </span>
    <span *ngIf="input?.type && input?.value === null">
      <em>No value</em>
    </span>
    <h4 class="text-danger" *ngIf="!(input?.type)">
      Input does not have a defined type!
    </h4>
`,
  styles: []
})
export class TypedDisplayComponent implements OnInit
{
  /**
   * The data and its type annotations.
   */
  @Input()
  public input : TypedDataHolder;

  @Input()
  public value : any;
  @Input()
  public wrapper : TypedDataHolder;

  @Input()
  public index : number;

  public specifiesSubelement () : boolean
  {
    return Number.isInteger(this.index) && Array.isArray(this.input.value);
  }
  public arraylike () : boolean
  {
    if (this.input.cardinality === 0 || this.input.cardinality > 1)
    {
      if (this.specifiesSubelement())
      {
        return false;
      }
      return true;
    }
    return false;
  }
  public val () : any
  {
    if (this.specifiesSubelement())
    {
      return this.input.value[this.index];
    }
    return this.input.value;
  }

  /**
   * Verify that the configuration is valid.
   */
  public ngOnInit () : void
  {
    // Verify required attributes are set
    if (!this.input)
    {
      if (!this.wrapper || this.value === undefined)
      {
        throw new Error("Typed-display must have input or value-wrapper pair");
      }
      else
      {
        this.input = Object.assign(this.wrapper, {value: this.value});
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/data/typed-display.component.ts